"use client";

import ThankYouMessageCard from "@/app/components/appcomponents/ThankYouMessageCard";
import { SecondaryButton } from "./parts";

/** "Pregled": the finished message exactly as it will appear on the home page. Nothing in it reacts to clicks. */
export default function Preview({ message, onClose }) {
  return (
    <div
      className="fixed inset-0 z-[10001] flex items-start justify-center overflow-y-auto bg-[#000000B3] px-3 py-8"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div role="dialog" aria-modal="true" aria-label="Predogled sporočila" className="flex w-full max-w-[660px] flex-col items-center gap-6">
        <div className="pointer-events-none w-full">
          <ThankYouMessageCard message={message} hideOpen />
        </div>
        <SecondaryButton onClick={onClose} className="px-10">
          Nazaj
        </SecondaryButton>
      </div>
    </div>
  );
}
